module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/person-advising-other-person-b909b6b93b73d414bd4a722723fe1d6f.jpg";